import styled from "styled-components";
import css from "@styled-system/css";
import { LayoutProps } from "styled-system";

import Card from "../Card/Card";
import Box from "../Box/Box";
import Typography from "../Typography/Typography";
import Container from "../Container/Container";
import Button from "../Button/Button";

const StyledCard = styled(Card)`
  overflow: hidden;
  position: relative;
  display: flex;
  padding: 0;
  margin: 0;
  @media (hover: hover) {
    ${css({
      "&:hover button": {
        color: "text-color-over-background",
      },
      "&:focus-within button": {
        color: "text-color-over-background",
      },
    })};
  }
`;

const StyledContainer = styled(Container)`
  position: absolute;
  transition: all 0.5s;
  transform: scale(1);
  z-index: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  @media (hover: hover) {
    ${css({
      "&:hover": {
        transform: "scale(1.1)",
      },
      "&:focus-within": {
        transform: "scale(1.1)",
      },
    })};
  }
`;

const StyledButton = styled(Button)`
  @media (hover: hover) {
    ${css({
      "&:not([disabled]):focus, &:not([disabled]):hover": {
        color: "text-color-over-background",
      },
    })};
  }
`;

interface CardContent {
  headline: string;
  image?: { url: string; overlay?: 0 | 0.25 | 0.5 | 0.75 };
  moreInfo?: {
    label: string;
    visible: boolean;
  };
  isSmallCard?: boolean;
  width?: LayoutProps["width"];
}

export default function FullImageCard({
  headline,
  image,
  moreInfo,
  isSmallCard,
  width = "300px",
}: CardContent) {
  return (
    <StyledCard
      width={width}
      height={isSmallCard ? "170px" : "360px"}
      aria-label={isSmallCard ? "full image small card" : "full image card"}
      variant="hoverable"
    >
      {image && (
        <StyledContainer
          backgroundImage={image?.url}
          backgroundSize="cover"
          overlayType="dark"
          overlay={image.overlay || 0}
        />
      )}
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="flex-end"
        alignItems="flex-start"
        p={6}
      >
        <Typography
          variant="h5"
          textAlign="left"
          color="text-color-over-background"
          css={`
            margin: 0px;
            position: relative;
          `}
        >
          {headline}
        </Typography>
        {moreInfo && moreInfo.visible && (
          <StyledButton
            variant="tertiary"
            text={moreInfo.label}
            width="fit-content"
            height="fit-content"
            textAlign="start"
            mt={2}
            p={0}
            css={`
              position: relative;
            `}
          />
        )}
      </Box>
    </StyledCard>
  );
}
